import { render, staticRenderFns } from "./OrgDemandsList.vue?vue&type=template&id=4d070270&scoped=true&"
import script from "./OrgDemandsList.vue?vue&type=script&lang=js&"
export * from "./OrgDemandsList.vue?vue&type=script&lang=js&"
import style0 from "./OrgDemandsList.vue?vue&type=style&index=0&id=4d070270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d070270",
  null
  
)

export default component.exports